import React from "react";

export type TableEmptyStateProps = {
  heading?: string;
  helper?: string;
  /** Shows the red clear button when set. */
  onClear?: () => void;
  clearLabel?: string;
  icon?: "search" | "document";
};

// Claude Design ds-components/TableEmptyState: shown in a filterable table's
// body when no rows match.
export const TableEmptyState = ({
  heading = "No results found",
  helper = "Try adjusting your search or filters to find what you're looking for",
  onClear,
  clearLabel = "Clear All Filters",
  icon = "search",
}: TableEmptyStateProps) => (
  <div className="flex flex-col items-center justify-center gap-[14px] px-6 py-[clamp(38px,7vw,64px)] text-center font-['DM_Sans',sans-serif]">
    <svg
      aria-hidden="true"
      width="56"
      height="56"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#9E9E9E"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {icon === "document" ? (
        <>
          <path d="M14 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8z" />
          <path d="M14 4v4h4" />
        </>
      ) : (
        <>
          <circle cx="11" cy="11" r="6.5" />
          <path d="M20 20l-4.4-4.4" />
        </>
      )}
    </svg>
    <strong className="text-[17px] font-semibold text-[#0A0A0A]">{heading}</strong>
    <span className="max-w-[380px] text-[14px] leading-[1.55] text-[#727272]">
      {helper}
    </span>
    {onClear ? (
      <button
        type="button"
        onClick={onClear}
        className="mt-[6px] rounded-[8px] border-0 bg-[#F21B1B] px-[26px] py-[12px] text-[14px] font-bold text-white hover:bg-[#D01414]"
      >
        {clearLabel}
      </button>
    ) : null}
  </div>
);

export default TableEmptyState;
